import React from "react";
import { JSX } from "react/jsx-runtime";

const ThumbsUpIcon = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => {
  return (
    <svg width="39" height="35" viewBox="0 0 39 35" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clip-path="url(#clip0_1433_14)">
            <ellipse cx="19.5001" cy="17.1853" rx="18.5714" ry="17.1853" fill="#2AC141" fill-opacity="0.1"/>
            <path d="M19.5 0.5C29.5178 0.5 37.5713 8.00634 37.5713 17.1855C37.5711 26.3646 29.5177 33.8701 19.5 33.8701C9.48236 33.87 1.42887 26.3646 1.42871 17.1855C1.42871 8.00638 9.48226 0.50007 19.5 0.5Z" stroke="#2AC141" stroke-opacity="0.5"/>
            <path d="M15.0007 23.2234L18.7607 24.0966C18.9193 24.1335 19.0822 24.1523 19.2457 24.1523H23.2637C23.6352 24.1523 23.9994 24.0562 24.3154 23.8747C24.6314 23.6933 24.8867 23.4336 25.0527 23.1249L28.5527 16.6224C28.7051 16.3392 28.777 16.0244 28.7616 15.7081C28.7463 15.3918 28.6441 15.0844 28.4649 14.815C28.2856 14.5457 28.0353 14.3234 27.7375 14.1692C27.4398 14.015 27.1046 13.9341 26.7637 13.9341H21.9997H19.9997M15.0007 23.2234L14.9997 14.863L18.3917 10.1366C18.7887 9.58387 18.9997 8.93547 18.9997 8.27129C18.9997 7.80775 19.4047 7.43153 19.9047 7.43153H20.0007C20.5312 7.43153 21.0399 7.62727 21.415 7.97569C21.79 8.32411 22.0007 8.79666 22.0007 9.2894V13.9341M15.0007 23.2234H12.9997C12.4693 23.2234 11.9606 23.0277 11.5855 22.6793C11.2105 22.3308 10.9997 21.8583 10.9997 21.3655V15.7919C10.9997 15.2992 11.2105 14.8266 11.5855 14.4782C11.9606 14.1298 12.4693 13.9341 12.9997 13.9341H15.4997" stroke="#0ACA27" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
            <clipPath id="clip0_1433_14">
            <rect width="39" height="34.3706" fill="white"/>
            </clipPath>
        </defs>
    </svg>

  );
};

export default ThumbsUpIcon; 